import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import { FilePond, registerPlugin } from 'react-filepond';
import { useTranslation } from 'react-i18next';

import 'filepond/dist/filepond.min.css';

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import MDTypography from '../../../components/MDTypography';
import './filepond.css';
import { deleteFile } from '../../../api';

// Register filepond the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginImageTransform,
  FilePondPluginImageResize,
  FilePondPluginFileValidateSize,
);

function FileUpload({ filePond, imageUrl, toggleButtons }) {
  const [files, setFiles] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (imageUrl) {
      const myFiles = [{
        source: `${imageUrl}?t=${Date.now()}`,
        options: {
          type: 'local',
        },
      }];
      setFiles(myFiles);
    }
  }, [imageUrl]);

  return (
    <Grid item xs={12}>
      <MDTypography variant="button" fontWeight="regular" color="text">{t('workouts.photo')}</MDTypography>
      <FilePond
        ref={filePond}
        onprocessfilestart={toggleButtons}
        onprocessfiles={toggleButtons}
        files={files}
        onupdatefiles={setFiles}
        allowMultiple={false}
        maxFiles={1}
        acceptedFileTypes="image/jpeg, image/png, image/gif, image/jpg"
        imageResizeTargetWidth={600}
        imageResizeTargetHeight={600}
        imageResizeMode="cover"
        server={{
          url: '/api/fileUpload/workout',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          load: (uniqueFileId, load, error) => {
            fetch(uniqueFileId)
              .then((res) => res.blob())
              .then(load)
              .catch(error);
          },
          revert: (uniqueFileId, load, error) => {
            deleteFile(uniqueFileId)
              .then(() => {
                load();
              })
              .catch(error);
          },
        }}
        name="file"
        labelIdle={t('general.drag.n.drop')}
        credits={false}
      />
    </Grid>
  );
}

FileUpload.defaultProps = {
  imageUrl: null,
};

FileUpload.propTypes = {
  filePond: PropTypes.oneOfType([PropTypes.object]).isRequired,
  imageUrl: PropTypes.string,
  toggleButtons: PropTypes.func.isRequired,
};

export default FileUpload;
